import { Link } from 'react-router-dom';
import Footer from '../components/Footer';
import NtakHeaderNew from '../components/HeaderNew/Ntakheader';
import NtakNavBar from '../components/NavBar/Ntaknavbar';
import CardList from '../components/Sections/CardListPos';
import ImageContent from '../components/Sections/ImageContent';
import MultipleCards from '../components/Sections/MultipleCards';
import Pricing from '../components/Sections/Pricing';
import TextSection from '../components/Sections/TextSection';
import Contact from './contact';

function Pos(props) {
  return (
    <main className='main-container' id='main-container'>
      <NtakNavBar />
      <NtakHeaderNew
        titleText='BarSoft POS'
        description={
          <div style={{ fontSize: '1.2em' }}>
            {' '}
            Egyszerű és komplex intelligens megoldásainkkal megkönnyítjük az értékesítést és rendelés felvételt a vendéglátásban. <br /> <br /> Értékesíts hatékonyan a BarSoft éttermi szoftver segítségével{' '}
            <Link to={'/ntak'}>
              <span style={{ fontWeight: 900, color: 'white' }}>NTAK</span>
            </Link>{' '}
            megfeleléssel!{' '}
            <p>
              {' '}
              <b>Próbáld ki most!</b>{' '}
            </p>{' '}
          </div>
        }
        lightImage='/assets/ntakheader.png'
        darkImage='/assets/ntakheader.png'
        theme={props.theme}
        haveDemo={true}
      />
      <div className='pos-features'>
        <h1>Széleskörű POS megoldások a te igényeidre szabva!</h1>
        <p>A BarSoft POS szerteágazó funkcióival és integrációival személyre szabva kezelheted üzleted értékesítési stratégiáját innovatív technológiák segítségével!</p>
        <div className='tabletPos'>
          <div className='left'>
            <div className='element'>
              <p>Adóügyi integráció</p>
              <span className='desc'>Online pénztárgép integráció QR kóddal vagy adóügyi nyomtaóval</span>
            </div>
            <div className='element'>
              <p>Bankkártya integráció</p>
              <span className='desc'>Vezeték nélküli kapcsolattal</span>
            </div>
            <div className='element'>
              <p>Soft POS</p>
              <span className='desc'>Teljesen integrált fizetési megoldások</span>
            </div>
          </div>
          <div className='center'>
            <img src='/assets/tabletPos.png' alt='hello' />
          </div>
          <div className='right'>
            <div className='element'>
              <p>Pincérterminálok újragondolva</p>
              <span className='desc'>További mobil POS-ok</span>
            </div>

            <div className='element'>
              <p>OrderManager</p>
              <span className='desc'>Hozd ki a maximumot pultjaidból - Rendeléskezelő funkció</span>
            </div>
          </div>
        </div>
      </div>

      <MultipleCards title='Felületünket kimondottan úgy alakítottuk ki, hogy tisztán átlátható legyen, gyors és pontos munkavégzést idézzünk elő.' desc='A termékeket akár POS gépén is fel tudja vinni szoftverünkbe, kategóriákba sorolva, hogy pár koppintással / kattintással villámgyorsan hozzáférhető legyen.' page={'pos'} showDetailsButton={false} />

      <ImageContent title='Mobil eszközzel szeretne értékesíteni?' description='Reszponzív vendéglátóipari szoftverünk ebben is hűséges társa lesz, hiszen kis kijelzőkre is optimalizáltuk szoftverünket! Keressen terméket, üsse fel gyorsan, szűrjön kategóriákra, húzza el jobbra a kijelzőn az ujját a kosárnézet megnyitásához!' imageSource='assets/posMobil.png' imageSide={'right'} />

      <div className='pos-devices'>
        <div>
          <h1>Lépj be a jövőbe a BarSoft segítségével!</h1>
          <h3>Kompakt megoldásaink segítségével redukálhatod az eszközök számát úgy, hogy közben minden kötelező megfeleltetésnek eleget teszel!</h3>
        </div>
        <div className='device-container'>
          <div className='device'>
            <div className='device-image'>
              <img src='/assets/devices/first.png' alt='hello' />
            </div>
            <div className='text'>
              <h3>Mobil készülék + SoftPOS + Vezeték nélküli Adóügyi nyomtató / QR kódos pénztárgép</h3>
              <p>Élvezd a kompakt technológiát! Értékesíts mobilon, vagy közvetlenül a Bankkártya terminálon!</p>
            </div>
          </div>
          <div className='device'>
            <div className='device-image'>
              <img src='/assets/devices/second.png' alt='hello' />
            </div>
            <div className='text'>
              <h3>Bankkártya terminál és POS egy eszközön</h3>
              <p>Üsd fel a rendelést és fizettess egyből bankkártyával egy eszközön! QR kódos adóügyi integrációnk segítségével minden gondot leveszünk a válladról!</p>
            </div>
          </div>
          <div className='device'>
            <div className='device-image'>
              <img src='/assets/devices/third.png' alt='hello' />
            </div>
            <div className='text'>
              <h3>Másodkijelzős Tablet NFC integrációval Soft POS-al és adóügyi nyomtatóval vagy QR kódos pénztárgéppel!</h3>
              <p>Ha fontos számodra az elegancia és a kompakt design, akkor ez lesz a te megoldásod! Innovatív eszközünk segítségével a másodkijelzőbe épített NFC olvasón végbe tud menni a fizetés, nincs szükség többé külön bankkártya terminálra!</p>
            </div>
          </div>
          <div className='device'>
            <div className='device-image'>
              <img src='/assets/devices/fourth.png' alt='hello' />
            </div>
            <div className='text'>
              <h3>Kompakt tablet NFC olvasóval Soft POS rendszerrel és adóügyi integrációval</h3>
              <p>
                Minél kisebb helyet szeretnél foglalni eszközeiddel a pulton? Válaszd a BarSoft-ot most, mi megvalósítjuk amit szeretnél! Csupán 2 eszközzel mindent meg tudsz oldani!
                <br /> Jól hangzik ugye?
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className='pos-theme'>
        <div>
          <h1>A BarSoft technológia</h1>
          <h3>Könnyen használható felület személyre szabva Módosítsd az értékesítési felületed úgy, ahogyan szeretnéd!</h3>
          <h3>A BarSoft rendszerét úgy alkottuk meg, hogy teljesen személyre tudd szabni.</h3>
        </div>
        <div className='device-container'>
          <div className='device colors'>
            <h3>Változtasd meg a színeket</h3>
          </div>
          <div className='device position'>
            <h3>Változtasd meg a kosár helyzetét</h3>
          </div>
          <div className='device category-position'>
            <h3>Módosítsd a kategóriák elhelyezését</h3>
          </div>
          <div className='device size'>
            <h3>Növeld meg a termék kártyáid méretét vagy éppen kisebbre is veheted</h3>
          </div>
          <div className='device font'>
            <h3>Ha nem tetszik a betűtípus választhatsz hogy melyik a legjobb számodra</h3>
          </div>
          <div className='device fontWeight'>
            <h3>Betűméret, betűvastagság alap beállítási lehetőség nálunk</h3>
          </div>
          <div className='device darkMode'>
            <h3>Világos és Sötét mód</h3>
          </div>
        </div>
      </div>

      <ImageContent
        imageSource='assets/vivaTerminal.png'
        title='Bankkártya terminál és POS egy eszközön'
        description={
          <div>
            <p>Nem szeretne sok technikai eszközzel bajlódni az értékesítés során?</p>
            <p>A BarSoft-ot úgy fejlesztettük, hogy akár egy androidos bankkártya terminálon is üzemeljen, így egy eszközzel tud értékesíteni és bankkártyát eflogadni!VivaWallet(R) integrációnk segítségével a mai legújabb technológiai megoldások kiaknázásával lehetővé tettük, hogy ez megvalósuljon és Önnek csupán egy online pénztárgépre van már csak szüksége ahhoz, hogy megfeleljen a szigorú magyar jogszabályoknak!Ha szeretné a hibalehetőségeket még inkább csökkenteni, egy QR kód és QR kód olvasó segítségével a pénztárgéphez sem kell majd nyúlnia!</p>
          </div>
        }
        imageSide={'left'}
      />
      <TextSection
        dividerText='Order Manager'
        smallTitle='Nem csak a pultnál értékesit?'
        title='Akkor az Order Manager tökéletes az Ön számára'
        description={
          <div>
            <p>Order Manager funkciónk segítségével a KIOSK-on, vagy BrandApp-on vagy egyéb csatlakoztatott integráción (WOLT, FoodPanda) érkezett rendeléseit tudja kezelni. Ha szereti a minden egyben, kompakt megoldásokat, akkor akár POS eladó táblagépén egy kapcsoló segtségével már láthatja is a felületet, ahol elkezdheti kezelni a bejövő igényeket</p>
            <p>Ha szeretné külön kezelni a nem pultnál történt megrendeléseket, akkor egy külön tableten/kiejlzőn máris tudja használni az Order Manager funkciónkat.</p>
          </div>
        }
      />
      <CardList title='Funkciók' />
      <ImageContent
        title='Rendelés nyomonkövetés'
        description={
          <div>
            <p>Amennyibe beálltja a QR kódos visszakövetést mondjuk KIOSK esetében, vendégei LIVE adatot kaphatnak arról, hogy éppen hol tart rendelésük elkészitése</p>
            <p>Amennyiben KDS rendszerként használja Order Manager funkciókat, úgy a konyhán tudják jelezni a pult és a vendég felé is hogy hol tart a rendelés.</p>
          </div>
        }
        imageSource='assets/orderTracking.png'
        imageSide={'left'}
      />

      <div className='download' id='download' style={{ width: '90%', marginLeft: 'auto', marginRight: 'auto' }}>
        <div className='section-left' style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center' }}>
          <img alt='hello' className='section-image' src='/assets/downloadImage.png' style={{ width: '50%' }} />
          <div style={{ display: 'flex', flexDirection: 'column', gap: 10, justifyContent: 'center', alignItems: 'center', height: '100%', width: '50%' }}>
            <a href='https://download.okeoke.io/latest.exe'>
              <div className='download-btn'>
                <svg xmlns='http://www.w3.org/2000/svg' width='30' height='30' fill='none' viewBox='0 0 30 30'>
                  <path fill='#fff' d='m3.75 6.849 9.221-1.27v8.909H3.75v-7.64Zm0 16.302 9.221 1.271v-8.8H3.75v7.53Zm10.235 1.407L26.25 26.25V15.623H13.985v8.935Zm0-19.116v9.046H26.25V3.75L13.985 5.442Z' />
                </svg>
                Letöltöm Windows-ra
              </div>
            </a>

            <div style={{ height: 50, width: 169, overflow: 'visible' }}>
              <a href='https://play.google.com/store/apps/details?id=hu.barsoft.pos'>
                <svg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 169 50'>
                  <path fill='#000' d='M162.46 49.899H6.248C2.75 49.899 0 47.16 0 43.674V6.326C0 2.84 2.75.1 6.248.1H162.46c3.499 0 6.249 2.739 6.249 6.225v37.348c0 3.486-2.75 6.225-6.249 6.225Z' />
                  <path
                    fill='#fff'
                    stroke='#fff'
                    stroke-miterlimit='10'
                    stroke-width='.233'
                    d='M59.236 12.8c0 .995-.25 1.867-.875 2.49-.75.746-1.625 1.12-2.75 1.12-1.124 0-2-.374-2.749-1.12-.75-.747-1.125-1.619-1.125-2.74 0-1.12.375-1.991 1.125-2.738.75-.747 1.625-1.12 2.75-1.12.5 0 1 .124 1.499.373.5.249.875.498 1.125.871l-.625.623c-.5-.623-1.125-.872-2-.872-.75 0-1.5.25-2 .872-.624.498-.874 1.245-.874 2.116s.25 1.618.875 2.116 1.25.872 2 .872c.874 0 1.499-.25 2.124-.872.375-.373.625-.871.625-1.494h-2.75v-.995h3.625v.498Zm5.748-3.113H61.61v2.366h3.124v.871H61.61v2.365h3.374v.996H60.61v-7.47h4.374v.872Zm4.124 6.598h-1V9.687h-2.124v-.871h5.249v.871h-2.125v6.598Zm5.749 0v-7.47h1v7.47h-1Zm5.248 0h-1V9.687h-2.124v-.871h5.124v.871H79.98v6.598h.125Zm11.873-.996c-.75.747-1.625 1.12-2.75 1.12s-2-.373-2.75-1.12c-.749-.746-1.124-1.618-1.124-2.739 0-1.12.375-1.991 1.125-2.738.75-.747 1.624-1.12 2.75-1.12 1.124 0 1.999.373 2.749 1.12.75.747 1.124 1.618 1.124 2.739 0 1.12-.375 1.992-1.124 2.738Zm-4.75-.622c.5.498 1.25.871 2 .871s1.5-.249 2-.871c.5-.498.874-1.245.874-2.117 0-.87-.25-1.618-.874-2.116-.5-.498-1.25-.871-2-.871s-1.5.249-2 .871a2.998 2.998 0 0 0-.874 2.117c0 .871.25 1.618.875 2.116Zm7.249 1.618v-7.47h1.125l3.624 5.852V8.816h.999v7.47h-1l-3.873-6.1v6.1h-.875Z'
                  />
                  <path
                    fill='#fff'
                    d='M85.104 27.24c-3 0-5.374 2.242-5.374 5.354 0 2.988 2.375 5.353 5.374 5.353 3 0 5.374-2.24 5.374-5.353 0-3.237-2.375-5.353-5.374-5.353Zm0 8.466c-1.624 0-3-1.369-3-3.236 0-1.868 1.376-3.237 3-3.237 1.625 0 3 1.245 3 3.237 0 1.867-1.375 3.236-3 3.236Zm-11.622-8.465c-3 0-5.374 2.24-5.374 5.353 0 2.988 2.375 5.353 5.374 5.353 3 0 5.374-2.24 5.374-5.353 0-3.237-2.375-5.353-5.374-5.353Zm0 8.465c-1.625 0-3-1.369-3-3.236 0-1.868 1.375-3.237 3-3.237 1.624 0 3 1.245 3 3.237 0 1.867-1.376 3.236-3 3.236ZM59.61 28.86v2.24h5.374c-.125 1.245-.625 2.241-1.25 2.864-.75.747-2 1.618-4.124 1.618-3.374 0-5.873-2.614-5.873-5.976 0-3.361 2.624-5.976 5.873-5.976 1.75 0 3.124.748 4.124 1.619l1.625-1.618c-1.375-1.245-3.124-2.241-5.624-2.241-4.499 0-8.373 3.735-8.373 8.216 0 4.482 3.874 8.217 8.373 8.217 2.5 0 4.25-.747 5.749-2.365 1.5-1.494 2-3.61 2-5.23 0-.497 0-.995-.126-1.369H59.61Zm56.736 1.743c-.499-1.245-1.749-3.361-4.498-3.361-2.75 0-4.999 2.116-4.999 5.353 0 2.988 2.249 5.353 5.248 5.353 2.375 0 3.875-1.494 4.374-2.365l-1.749-1.245c-.625.871-1.375 1.494-2.625 1.494-1.249 0-1.999-.498-2.624-1.618l7.123-2.988-.25-.623Zm-7.248 1.743c0-1.992 1.625-3.112 2.75-3.112.874 0 1.749.498 1.999 1.12l-4.749 1.992Zm-5.873 5.104h2.374V21.888h-2.374v15.561Zm-3.75-9.088c-.624-.622-1.624-1.245-2.874-1.245-2.624 0-5.123 2.366-5.123 5.354s2.374 5.228 5.123 5.228c1.25 0 2.25-.622 2.75-1.245h.125v.747c0 1.992-1.125 3.113-2.875 3.113-1.374 0-2.374-.996-2.624-1.868l-2 .872c.625 1.37 2.125 3.112 4.75 3.112 2.749 0 4.998-1.618 4.998-5.478V27.49h-2.25v.871Zm-2.749 7.345c-1.624 0-2.999-1.369-2.999-3.236 0-1.868 1.375-3.237 3-3.237 1.624 0 2.873 1.37 2.873 3.237s-1.25 3.236-2.874 3.236Zm30.493-13.818h-5.624V37.45h2.375V31.6h3.249c2.624 0 5.124-1.868 5.124-4.856 0-2.988-2.5-4.855-5.124-4.855Zm.125 7.47h-3.374v-5.354h3.374c1.749 0 2.749 1.494 2.749 2.614-.125 1.37-1.125 2.74-2.749 2.74Zm14.371-2.242c-1.749 0-3.499.747-4.124 2.366l2.125.871c.5-.871 1.249-1.12 2.124-1.12 1.25 0 2.375.747 2.5 1.992v.124c-.375-.249-1.375-.622-2.375-.622-2.249 0-4.499 1.245-4.499 3.486 0 2.116 1.875 3.485 3.874 3.485 1.625 0 2.375-.747 3-1.493h.125v1.244h2.249v-5.975c-.25-2.74-2.374-4.358-4.999-4.358Zm-.25 8.59c-.75 0-1.874-.373-1.874-1.369 0-1.245 1.374-1.618 2.499-1.618 1 0 1.5.249 2.125.498-.25 1.494-1.5 2.49-2.75 2.49Zm13.122-8.216-2.624 6.723h-.125l-2.75-6.723h-2.499l4.124 9.461-2.374 5.23h2.374l6.373-14.691h-2.499Zm-20.995 9.96h2.375V21.887h-2.375v15.561Z'
                  />
                  <path fill='url(#b)' d='M12.997 9.438c-.375.374-.5.996-.5 1.743v27.513c0 .747.25 1.37.625 1.743l.125.125 15.496-15.438v-.248L12.997 9.437Z' />
                  <path fill='url(#c)' d='m33.742 30.353-5.124-5.104v-.374l5.124-5.104.125.125 6.123 3.485c1.75.997 1.75 2.615 0 3.61l-6.248 3.362Z' />
                  <path fill='url(#d)' d='m33.867 30.229-5.249-5.23-15.62 15.563c.624.622 1.499.622 2.623.124L33.867 30.23Z' />
                  <path fill='url(#e)' d='M33.867 19.771 15.621 9.438c-1.124-.622-2-.498-2.624.125L28.618 25l5.249-5.229Z' />
                  <path fill='#000' d='m33.742 30.104-18.12 10.209c-1 .622-1.875.498-2.5 0l-.125.124.125.125c.625.498 1.5.622 2.5 0l18.12-10.458Z' opacity='.2' />
                  <path fill='#000' d='M12.997 40.313c-.375-.374-.5-.996-.5-1.743v.124c0 .747.25 1.37.625 1.743v-.124h-.125ZM39.99 26.618l-6.248 3.486.125.125 6.123-3.486c.875-.498 1.25-1.12 1.25-1.743 0 .622-.5 1.12-1.25 1.618Z' opacity='.12' />
                  <path fill='#fff' d='m15.621 9.563 24.37 13.818c.75.498 1.25.997 1.25 1.619 0-.622-.376-1.245-1.25-1.743L15.62 9.438c-1.75-.996-3.124-.249-3.124 1.743v.125c0-1.868 1.375-2.74 3.124-1.743Z' opacity='.25' />
                  <defs>
                    <linearGradient id='b' x1='27.244' x2='6.35' y1='10.945' y2='31.917' gradientUnits='userSpaceOnUse'>
                      <stop stop-color='#00A0FF' />
                      <stop offset='.007' stop-color='#00A1FF' />
                      <stop offset='.26' stop-color='#00BEFF' />
                      <stop offset='.512' stop-color='#00D2FF' />
                      <stop offset='.76' stop-color='#00DFFF' />
                      <stop offset='1' stop-color='#00E3FF' />
                    </linearGradient>
                    <linearGradient id='c' x1='42.282' x2='12.043' y1='25.001' y2='25.001' gradientUnits='userSpaceOnUse'>
                      <stop stop-color='#FFE000' />
                      <stop offset='.409' stop-color='#FFBD00' />
                      <stop offset='.775' stop-color='orange' />
                      <stop offset='1' stop-color='#FF9C00' />
                    </linearGradient>
                    <linearGradient id='d' x1='31.026' x2='2.694' y1='27.858' y2='56.299' gradientUnits='userSpaceOnUse'>
                      <stop stop-color='#FF3A44' />
                      <stop offset='1' stop-color='#C31162' />
                    </linearGradient>
                    <linearGradient id='e' x1='9.119' x2='21.771' y1='.32' y2='13.021' gradientUnits='userSpaceOnUse'>
                      <stop stop-color='#32A071' />
                      <stop offset='.069' stop-color='#2DA771' />
                      <stop offset='.476' stop-color='#15CF74' />
                      <stop offset='.801' stop-color='#06E775' />
                      <stop offset='1' stop-color='#00F076' />
                    </linearGradient>
                    <clipPath id='a'>
                      <path fill='#fff' d='M0 0h168.709v50H0z' />
                    </clipPath>
                  </defs>
                </svg>
              </a>
            </div>
          </div>
        </div>
        <div className='section-right '>
          <div className='text-section'>
            <h1 className='section-label highlighted-text'>Készen állsz, hogy NTAK kompatibilis legyen üzleted?</h1>
            <p>
              Válaszd a BarSoft rendszerét, és hagyd magad mögött a stresszt, idegeskedést és az NTAK megfeleléssel járó egyéb időveszteséget! <br /> <br /> <span className='highlighted-text'>Töltsd le szoftverünket és használd TELJESEN INGYEN az ÖSSZES FUNKCIÓT július 31-ig!</span>
              <br /> <br /> Ne feledd: Július 31 után is tudod ingyen használni a BarSoft rendszerét!
            </p>
          </div>
        </div>
      </div>
      <Pricing />
      <Contact />
      <Footer />
    </main>
  );
}

export default Pos;
